import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * حماية المسار: التحقق من المصادقة واختيارياً من الأدوار
 * @param {string[]} allowedRoles - أدوار مسموحة (فارغ = أي مستخدم مسجل)
 * @param {boolean} studentOnly - إذا true يقبل STUDENT فقط (للمسار /student)
 * @param {boolean} adminOnly - إذا true يقبل غير STUDENT (للمسار /dashboard)
 */
const ProtectedRoute = ({ children, allowedRoles = [], studentOnly = false, adminOnly = false }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (studentOnly) {
    if (user?.role !== 'STUDENT') {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }

  if (adminOnly) {
    if (user?.role === 'STUDENT') {
      return <Navigate to="/student" replace />;
    }
    return children;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    if (user?.role === 'STUDENT') {
      return <Navigate to="/student" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
